'use strict'

import './shopify-manager'
